import pb from './pocketbaseClient';

export const PLATFORMS = [
  { value: 'amazon',   label: 'Amazon' },
  { value: 'flipkart', label: 'Flipkart' },
  { value: 'meesho',   label: 'Meesho' },
  { value: 'myntra',   label: 'Myntra' },
];

export const CATEGORIES = [
  'Electronics', 'Fashion', 'Home & Kitchen', 'Beauty', 'Sports',
  'Books', 'Toys', 'Furniture', 'Home Decor', 'Lighting',
  'Kitchen Appliances', 'Tools & Hardware', 'Garden', 'Automotive',
];

export function fileUrl(record, filename) {
  if (!filename || !record) return '';
  const base = pb.baseUrl || 'https://housedesigns99.com';
  return base + '/api/files/store_products/' + record.id + '/' + filename;
}

export async function listStoreProducts(opts) {
  opts = opts || {};
  const page = opts.page || 1;
  const perPage = opts.perPage || 20;
  const search = opts.search || '';
  const platform = opts.platform || '';
  const category = opts.category || '';
  const status = opts.status || '';

  const parts = [];
  if (search) parts.push('(title ~ "' + search + '" || brand ~ "' + search + '")');
  if (platform) parts.push('platform = "' + platform + '"');
  if (category) parts.push('category = "' + category + '"');
  if (status === 'active')   parts.push('isActive = true');
  if (status === 'inactive') parts.push('isActive = false');
  if (status === 'featured') parts.push('isFeatured = true');

  const filterStr = parts.join(' && ');

  const query = { sort: '-id' };
  if (filterStr) query.filter = filterStr;  // only set if non-empty

  return pb.collection('store_products').getList(page, perPage, query);
}

export async function deleteStoreProduct(id) { return pb.collection('store_products').delete(id); }
export async function toggleActive(id, v)   { return pb.collection('store_products').update(id, { isActive: v }); }
export async function toggleFeatured(id, v) { return pb.collection('store_products').update(id, { isFeatured: v }); }
export function slugify(s) {
  return String(s || '').toLowerCase().trim().replace(/[^\w\s-]/g, '').replace(/\s+/g, '-').replace(/-+/g, '-').slice(0, 120);
}
export async function upsertStoreProduct(id, fd) {
  if (id) return pb.collection('store_products').update(id, fd);
  return pb.collection('store_products').create(fd);
}
